{
  "welcome": {
    "title": "Te damos la bienvenida, {{name}}",
    "title_noName": "Te damos la bienvenida a Rhemn",
    "body": "Todo lo que brilla te muestra lo que hace. Explora en el orden que quieras, cuando quieras.",
    "start": "Empezar a explorar",
    "later": "Ahora no"
  },
  "card": {
    "tryIt": "Probar",
    "takeALook": "Echar un vistazo",
    "pro": "Incluido en Rhemn Pro",
    "close_aria": "Cerrar"
  },
  "pill": {
    "progress": "{{count}} de {{total}} explorados",
    "progress_short": "{{count}} de {{total}}",
    "done": "Hecho",
    "done_aria": "Terminar de explorar",
    "complete": "Todo explorado"
  },
  "sr": {
    "started": "Modo explorar activado. Los botones muestran lo que hacen antes de actuar.",
    "hint": "Modo explorar. Primero muestra lo que hace.",
    "ended": "Modo explorar desactivado."
  },
  "settings": {
    "row": "Cómo funciona Rhemn",
    "row_sub": "Un breve vistazo a cada parte",
    "row_aria": "Cómo funciona Rhemn: explora la app de nuevo",
    "helpCaption": "Ayuda"
  },
  "steps": {
    "intention": {
      "title": "La intención de hoy",
      "body": "Escribe lo que más importa hoy y márcalo cuando esté hecho."
    },
    "now": {
      "title": "Tu día, por oraciones",
      "body": "Rhemn divide tu día en cada oración. Aquí ves el tiempo que queda para la siguiente y lo que has planeado para ese tramo."
    },
    "verse": {
      "title": "Perspectivas del versículo",
      "body": "Haz una pregunta sobre el versículo de hoy, lee un breve tafsir y encuentra versículos sobre el mismo tema."
    },
    "qibla": {
      "title": "Dirección de la Qibla",
      "body_chrome": "La dirección de la Kaaba desde donde estás, en grados desde el norte.",
      "body_ios": "Señala la Kaaba desde donde estás. Activa la brújula en vivo y te seguirá mientras giras."
    },
    "prayer": {
      "title": "Horarios de oración",
      "body_chrome": "Los cinco horarios de oración de hoy para donde estás. Elige el método de cálculo que sigue tu mezquita.",
      "body_ios": "Tu próxima oración de un vistazo. Ábrela para ver los cinco horarios y un recordatorio para cada uno."
    },
    "tasks": {
      "title": "Tareas",
      "body": "Organiza tus pendientes en listas y dale a cada uno un lugar entre las oraciones."
    },
    "notes": {
      "title": "Notas",
      "body_chrome": "Escribe, o simplemente habla. Rhemn transcribe tus notas de voz y reuniones, y luego las resume.",
      "body_ios": "Escribe, o simplemente habla. Rhemn convierte lo que dices en notas claras y resumidas."
    },
    "profile": {
      "title_chrome": "Tu perfil",
      "body_chrome": "Tu cuenta y tus ajustes de privacidad. Vuelve aquí para explorar Rhemn de nuevo.",
      "title_ios": "Más",
      "body_ios": "Versículos guardados, Qibla y los ajustes de tu cuenta. Desde aquí puedes explorar Rhemn de nuevo."
    }
  }
}
